module.exports = __webpack_public_path__ + "img/tr.1200e409.svg";